import React, { Component } from 'react';
import GoogleAnalytics from 'react-ga';
import TagManager from 'react-gtm-module'

import { THEME } from '../configs/global';

let gkey = THEME.GA.KEY;

if (window.location.hostname === 'coachtracker.nationalexpress.com') {
  gkey='UA-22502992-7';
} else if (window.location.hostname === 'coachtracker.dublinexpress.ie') {
  gkey='UA-22502992-14';
}

if (gkey) {
  GoogleAnalytics.initialize(gkey);
}

function withTracker (WrappedComponent, options = {}) {
  let gtmId = THEME.GTM.KEY ? THEME.GTM.KEY : '';
  if (window.location.hostname === 'coachtracker.nationalexpress.com') {
    gtmId = 'GTM-NPWVLLL';
  } else if (window.location.hostname === 'coachtracker.dublinexpress.ie') {
    gtmId = 'GTM-N73WW6W';
  }
  
  const tagManagerArgs = {
    gtmId: gtmId
  }  
  const trackPage = page => {
    if (tagManagerArgs.gtmId) {
      TagManager.initialize(tagManagerArgs);
    }
    GoogleAnalytics.set({
      page,
      ...options,
    });
    GoogleAnalytics.pageview(page);
  };

  const HOC = class extends Component {
    componentDidMount() {
      const page = this.props.location.pathname;
      trackPage(page);
    }
    
    componentWillReceiveProps(nextProps) {
      const currentPage = this.props.location.pathname;
      const nextPage = nextProps.location.pathname;

      if (currentPage !== nextPage) {
        trackPage(nextPage);
      }
    }

    render() {
      return <WrappedComponent { ...this.props}/>;
    }
  };

  return HOC;
};


export default withTracker;
  

  



// WEBPACK FOOTER //
// ./src/containers/withTracker.js